var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcSound = function SvgIcSound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21057 4.46718L22.624 2.79985V5.56651L9.21057 6.89165V4.46718ZM25.374 2.37535C25.374 0.947443 24.123 -0.157653 22.706 0.0184849L8.54261 1.77905C7.35337 1.92687 6.46057 2.93752 6.46057 4.13591V8.40919V9.92672L6.46062 9.92671V18.3769C5.95559 18.214 5.40332 18.1242 4.82468 18.1242C2.42166 18.1242 0.473633 19.6722 0.473633 21.5817C0.473633 23.4913 2.42166 25.0392 4.82468 25.0392C7.11808 25.0392 8.99705 23.6293 9.1637 21.8407H9.21062V9.65504L22.6238 8.32992V16.4432C22.1189 16.2803 21.5667 16.1906 20.9881 16.1906C18.5851 16.1906 16.6371 17.7386 16.6371 19.6481C16.6371 21.5577 18.5851 23.1057 20.9881 23.1057C23.2815 23.1057 25.1605 21.6957 25.3272 19.9071H25.3738V8.05824L25.374 8.05822V6.81237V2.37535Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcSound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_sound.59a6fe82.svg";
export { ForwardRef as ReactComponent };